var exports = {
  "l": "Dialog__4HnLjB",
};

module.exports = exports;
